import { ImgBgResponsive } from "@/src/component/base/ImgBgResponsive";
import { StrapiComponentType, ComponentType } from "@/src/type";
import { LoadFromCDN } from "@/src/util";

import { SectionModule, TextBreakpointModule, ButtonLinkModule } from "../component";

import styles from "./AvailableHomesBanner.module.scss";

interface AvailableHomesBannerProps extends ComponentType.DynamicPageSectionComponentProps<StrapiComponentType.Section.AvailableHomesBanner> {}

function AvailableHomesBanner({ section, slug, snapToGrid, classes, searchParams, quality, layout, lazy, mobileHint }: AvailableHomesBannerProps) {
  const banner: StrapiComponentType.Section.AvailableHomesBanner = section.type?.[0];

  return (
    <SectionModule
      section={section}
      slug={slug}
      classes={{
        section: classes?.section,
      }}
      layout={layout}
      stylePrefix="AvailableHomesBanner"
      styleContainerId={banner.id}
      snapToGrid={snapToGrid}
      searchParams={searchParams}
      quality={quality}
      lazy={lazy}
      mobileHint={mobileHint}
    >
      <div className={styles.banner}>
        <div className={styles.inner}>
          <div className={styles.image}>
            <ImgBgResponsive imageUrl={LoadFromCDN.imageSizeAndQuality(banner.image?.data?.attributes?.url ?? "", quality, 400)} />
          </div>
          <div className={styles.content}>
            <div className={styles.text}>
              <TextBreakpointModule
                id={`title_avail_banner_${banner.id}`}
                text={banner.title}
                className={styles.title}
              />
              <TextBreakpointModule
                id={`subtitle_avail_banner_${banner.id}`}
                text={banner.subtitle}
                className={styles.subtitle}
              />
            </div>
            <div className={styles.cta}>{banner.cta && <ButtonLinkModule buttonLink={banner.cta} />}</div>
          </div>
        </div>
      </div>
    </SectionModule>
  );
}

export default AvailableHomesBanner;
